const location = (): Location | undefined =>
	typeof window !== "undefined" ? window.location : undefined;

export const isProductionEnv = () => {
	const href = location()?.href ?? "";
	return href.indexOf("www.wevideo") > 0 || href.indexOf("eu.wevideo") > 0;
};
export const APP_VERSION = import.meta.env.VITE_PACKAGE_VERSION;
export const COMMIT_HASH = import.meta.env.VITE_COMMIT_HASH;
export const BRANCH = import.meta.env.VITE_BRANCH;

export const isLocalEnvironment = () => {
	const host = location()?.host ?? "";
	return host.indexOf("localhost") >= 0 || host.indexOf("192.168") >= 0;
};

export const isKeepLoggingEnabled = () => (location()?.search ?? "").indexOf("keepLogging") >= 0;
